/* eslint-disable max-len */
export default {
    title: {
        threats: 'Learn more about securing your data.',
        offer: 'Learn more about the tools for your comprehensive data security.',
        minimize: 'Do you want to minimize the risk of cyber attacks in your organization?',
        estimate: 'Do you want to increase security of your applications?',
        breach: 'Are you a victim of cyber attack?',
        // risk: 'Do you want to prepare your organization to become GDPR compliant?',
        audit: 'Do you want to prepare your application/IT system to become GDPR compliant?',
        bottom: 'Are you interested in a comprehensive solution for your data security?',
        contact: 'Contact us as soon as possible!'
    },
    placeholder: {
        email: 'Your company email',
        phone: 'Phone'
    },
    button: {
        offer: 'Schedule a meeting',
        consultation: 'Arrange a free consultation',
        breach: 'Check post-breach incident steps',
        refresh: 'Refresh'
        // risk: 'Get risk analysis'
    },
    message: {
        general_error: 'Please fill in all required fields correctly.',
        domain_error: 'We don\'t accept temporary email addresses. Type in the correct email address',
        recaptcha_error: 'Something went wrong, please hit the refresh button and try again.',
        server_error: 'Temporary server error. Schedule a meeting sending a message to contact@lemlock.com',
        success: 'Message was sent'
    },
    link: {
        breach: 'https://www.lemlock.com/post-breach-steps/'
    }
};



// WEBPACK FOOTER //
// ./src/i18n/en/form.js